/**
 * Tipos del gasto al proveedor de un embarque (shipping_expenses).
 *
 * Es un único gasto que cambia de etapa: nace como «Proform Supplier» y pasa a
 * «Invoice Supplier» cuando se cobra un pago suyo (payment.paid = true), sin importar
 * el importe. Ambas etapas se tratan igual en toda la UI.
 *
 * Los IDs son los sembrados en la lista «Type of costs» (mismo valor en todos los tenants);
 * el de proforma lo crea la migración `shipping_expense_proform_supplier_type_2026_08`.
 */
export const INVOICE_SUPPLIER_EXPENSE_TYPE_ID = "683b31db6094fed22e74537e";
export const PROFORM_SUPPLIER_EXPENSE_TYPE_ID = "683b31db6094fed22e7453f0";

export const SUPPLIER_EXPENSE_TYPE_IDS = [
  INVOICE_SUPPLIER_EXPENSE_TYPE_ID,
  PROFORM_SUPPLIER_EXPENSE_TYPE_ID,
];

/**
 * @param {string|{_id: string}|null|undefined} type valor de shipping_expenses.type
 * @returns {boolean} true si es el gasto al proveedor, en cualquiera de sus dos etapas
 */
export function isSupplierExpenseType(type) {
  if (!type) return false;
  const id = typeof type === "object" && type._id ? type._id : type;
  return SUPPLIER_EXPENSE_TYPE_IDS.includes(String(id));
}

/**
 * @param {string|{_id: string}|null|undefined} type valor de shipping_expenses.type
 * @returns {boolean} true si el gasto al proveedor todavía está en la etapa proforma
 */
export function isProformSupplierExpenseType(type) {
  if (!type) return false;
  const id = typeof type === "object" && type._id ? type._id : type;
  return String(id) === PROFORM_SUPPLIER_EXPENSE_TYPE_ID;
}
